import { parseHdmiPort } from './launcherTopology';

export function getMediaPlaybackOptions({ choices = [], devices = [], selectedTargetId }) {
  const preferred = [...devices].sort((a, b) =>
    Number(Number(b.target.id) === Number(selectedTargetId)) - Number(Number(a.target.id) === Number(selectedTargetId))
    || Number(a.switchRequired) - Number(b.switchRequired));
  const available = preferred.filter((device) => device.switchReady !== false);
  const apps = new Map();
  available.forEach((device) => {
    choices.filter((choice) => choice.installed === true && choice.launchSupported
      && [device.target.id, device.appControlDeviceId].some((id) => Number(id) === Number(choice.targetDeviceId)))
      .forEach((choice) => {
        const key = ['youtube', 'spotify'].includes(choice.adapterKey)
          ? choice.adapterKey : choice.packageName || choice.adapterKey;
        if (!apps.has(key)) apps.set(key, { choice, device });
      });
  });
  return {
    apps: Array.from(apps.values()),
    suitestream: available.find((device) => device.suitestreamApp) || null,
  };
}

export function getMediaInputWarning(device, state) {
  const expectedPort = parseHdmiPort(device.expectedInput);
  const inputManager = state?.tvInputManager;
  const active = inputManager?.activeSource;
  const knownInput = active?.available === true && active.isStale !== true && inputManager.isStale !== true;
  if (expectedPort && knownInput && Number(active.port) === expectedPort) return '';
  if (!device.switchRequired && (!expectedPort || Number(device.target.id) === Number(device.screen?.televisionDeviceId))) return '';
  const input = device.expectedInput || 'its configured input';
  return `${device.screen?.name || 'This screen'} ${knownInput ? 'needs to switch' : 'may need to switch'} to ${input} to play on ${device.target.name}. This will interrupt what is currently showing. Continue?`;
}

export async function prepareMediaPlayback({ device, readState, stillSelected, confirm, prepare }) {
  let state;
  if (device.screen?.televisionDeviceId && parseHdmiPort(device.expectedInput)) {
    try {
      state = await readState(device.screen.televisionDeviceId);
    } catch (_error) {
      // Missing input evidence retains the warning and source preparation path.
    }
  }
  if (!stillSelected()) throw new Error('Selection changed; content was not launched.');
  const warning = getMediaInputWarning(device, state);
  if (warning && !confirm(warning)) return false;
  await prepare({ ...device, switchRequired: Boolean(warning) });
  if (!stillSelected()) throw new Error('Selection changed; content was not launched.');
  return true;
}
